import { Suspense } from 'react';
import LoadingWindow from './LoadingWindow';

interface PageSuspenseProps {
  children: React.ReactNode;
  message?: string;
}

const PageSuspense = ({ children, message = 'Loading...' }: PageSuspenseProps) => {
  return (
    <Suspense fallback={<LoadingWindow fullScreen={true} overlay={true} message={message} />}>
      {children}
    </Suspense>
  );
};

export default PageSuspense;